"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.TransactionStatus = exports.TransactionPaymentType = void 0;
var api_service_1 = require("./api-service");
var PaymentService = /** @class */ (function (_super) {
    __extends(PaymentService, _super);
    function PaymentService() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.endpoint = 'payments';
        return _this;
    }
    // Payment Methods
    PaymentService.prototype.methods = function (params) {
        return this.getCollectionRequest(this.url('methods'), { params: params });
    };
    PaymentService.prototype.createMethod = function (method) {
        return this.postRequest(this.url('methods'), method);
    };
    PaymentService.prototype.getMethod = function (id) {
        return this.getRequest(this.url('methods', id));
    };
    PaymentService.prototype.updateMethod = function (id, data) {
        return this.putRequest(this.url('methods', id), data);
    };
    PaymentService.prototype.deleteMethod = function (method) {
        return this.deleteRequest(this.url('methods', method));
    };
    // TODO: To be implemented in the future
    // Payment Authorization
    // public authorizations(params?: any): Promise<ResponseCollection<any>> {
    //   return this.getCollectionRequest(this.url('authorizations'), params)
    // }
    PaymentService.prototype.createAuthorization = function (authorization) {
        return this.postRequest(this.url('authorizations'), authorization);
    };
    // public getAuthorization(id: string): Promise<any> {
    //   return this.getRequest(this.url('authorizations', id))
    // }
    PaymentService.prototype.captureAuthorization = function (id) {
        return this.postRequest(this.url('authorizations', id, 'capture'));
    };
    PaymentService.prototype.completeAuthorization = function (id, data) {
        return this.postRequest(this.url('authorizations', id, 'completeAuthorize'), data);
    };
    // public completePurchase(id: any): Promise<any> {
    //   return this.postRequest(this.url('authorizations', id, 'completePurchase'))
    // }
    //
    // // Providers
    // public createProviderCallback(provider: any): Promise<any> {
    //   return this.postRequest(this.url('callback'), provider)
    // }
    // public getProviderCallback(provider: any): Promise<any> {
    //   return this.getRequest(this.url('callback', provider))
    // }
    // public updateProviderCallback(provider: string, data: any): Promise<any> {
    //   return this.putRequest(this.url('callback', provider), data)
    // }
    // public patchProviderCallback(provider: string, data: any): Promise<any> {
    //   return this.patchRequest(this.url('callback', provider), data)
    // }
    // public deleteProviderCallback(provider: string): Promise<any> {
    //   return this.deleteRequest(this.url('callback', provider))
    // }
    //
    // Cards
    PaymentService.prototype.cards = function (params) {
        return this.getCollectionRequest(this.url('cards'), { params: params });
    };
    PaymentService.prototype.getCard = function (id) {
        return this.getRequest(this.url('cards', id));
    };
    PaymentService.prototype.createCard = function (card) {
        return this.postRequest(this.url('cards'), card);
    };
    PaymentService.prototype.deleteCard = function (id) {
        return this.deleteRequest(this.url('cards', id));
    };
    // Payments
    // public payments(params?: any): Promise<ResponseCollection<any>> {
    //   return this.getRequest(this.url('payments'), params)
    // }
    // public createPayment(method: any): Promise<any> {
    //   return this.postRequest(this.url('payments'), method)
    // }
    // public getPayment(method: any): Promise<any> {
    //   return this.getRequest(this.url('payments', method))
    // }
    PaymentService.prototype.getPaymentsMethods = function () {
        return this.getRequest(this.url('payments', 'methods'));
    };
    // public updatePayment(method: string, data: any): Promise<any> {
    //   return this.putRequest(this.url('payments', method), data)
    // }
    // public refundPayment(id: string): Promise<any> {
    //   return this.postRequest(this.url('payments', id, 'refund'))
    // }
    // public voidPayment(id: string): Promise<any> {
    //   return this.postRequest(this.url('payments', id, 'void'))
    // }
    // Refunds
    // public refunds(params?: any): Promise<ResponseCollection<any>> {
    //   return this.getRequest(this.url('refunds'), params)
    // }
    // public getRefund(id: string): Promise<any> {
    //   return this.getRequest(this.url('refunds', id))
    // }
    PaymentService.prototype.converge = function (data) {
        return this.postRequest(this.url('converge', 'token'), data);
    };
    return PaymentService;
}(api_service_1.ApiService));
exports.default = PaymentService;
//Transactions
var TransactionPaymentType;
(function (TransactionPaymentType) {
    TransactionPaymentType["OFFLINE"] = "offline";
    TransactionPaymentType["ONLINE"] = "online";
})(TransactionPaymentType = exports.TransactionPaymentType || (exports.TransactionPaymentType = {}));
var TransactionStatus;
(function (TransactionStatus) {
    TransactionStatus[TransactionStatus["NEW"] = 0] = "NEW";
    TransactionStatus[TransactionStatus["PENDING"] = 1] = "PENDING";
    TransactionStatus[TransactionStatus["FINISHED"] = 2] = "FINISHED";
    TransactionStatus[TransactionStatus["CANCELED"] = 3] = "CANCELED";
    TransactionStatus[TransactionStatus["ERROR"] = 4] = "ERROR";
})(TransactionStatus = exports.TransactionStatus || (exports.TransactionStatus = {}));
//# sourceMappingURL=payment-service.js.map